module.exports = __webpack_public_path__ + "static/media/voice.bfa90eb4.svg";